import { gql } from '@apollo/client';

export const BANNED_EMAIL_DOMAINS = gql`
  query BannedEmailDomains {
    bannedEmailDomains {
      domain
      reason
      addedAt
    }
  }
`;
